import React from 'react';
import { Lock, Zap, Shield, CreditCard } from 'lucide-react';
import { Section, CTAButton } from './Shared';
const REFLEXO_HREF = 'https://www.lumenakasha.com/cart/46722804678845:1';
const ACELERADOR_HREF = 'https://www.lumenakasha.com/cart/46787506733245:1';
export const EmotionalClose = () => {
  return <Section className="max-w-4xl" data-id="element-39">
      <div className="glass-panel p-6 md:p-12 rounded-3xl text-center bg-white/80 border-brand-pink/30 shadow-lg" data-id="element-40">
        <h2 className="text-2xl md:text-4xl font-serif font-bold mb-8 text-brand-text leading-tight" data-id="element-41">
          Hay dos versiones de vos en este momento.
        </h2>

        <div className="space-y-5 text-base md:text-lg text-brand-text/80 mb-10 max-w-2xl mx-auto" data-id="element-42">
          <p data-id="element-43">Una que cierra esta página y la semana que viene sigue igual.</p>
          <p className="font-medium text-brand-rose" data-id="element-44">
            Y otra que decide que hoy es diferente.
          </p>
          <p className="font-serif italic text-lg md:text-xl" data-id="element-45">
            La pregunta no es si podés pagarlo.
            <br data-id="element-46" />
            La pregunta es si podés seguir sin hacerlo.
          </p>
        </div>

        <h3 className="text-xl md:text-3xl font-serif font-bold mb-8 text-brand-text" data-id="element-47">
          ¿CON CUÁL EMPEZÁS?
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 mb-10" data-id="element-48">
          {/* Plan 1 */}
          <div className="glass-panel rounded-2xl p-6 md:p-7 border-brand-pink/40 bg-white/80 text-center flex flex-col" data-id="element-49">
            <h4 className="font-serif font-bold text-lg md:text-xl text-brand-text mb-1" data-id="element-50">
              🦶 KIT REFLEXO-PRO
            </h4>
            <div className="text-3xl md:text-4xl font-bold text-brand-text mb-3" data-id="element-51">
              $19.990
            </div>
            <p className="text-sm text-brand-text/70 mb-5 flex-grow" data-id="element-52">
              Organizá tu gabinete y documentá tu trabajo desde hoy.
            </p>
            <CTAButton fullWidth className="text-sm md:text-base py-3.5" href="#pricing" data-id="element-53">
              🦶 → LO QUIERO $19.990
            </CTAButton>
          </div>

          {/* Plan 2 — featured */}
          <div className="glass-panel rounded-2xl p-6 md:p-7 border-2 border-brand-rose bg-white/90 text-center flex flex-col relative shadow-[0_10px_30px_rgba(212,115,140,0.15)]" data-id="element-54">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-brand-rose text-white text-[10px] md:text-xs font-bold px-3 py-1 rounded-full whitespace-nowrap" data-id="element-55">
              ⭐ MÁS ELEGIDO
            </div>
            <h4 className="font-serif font-bold text-lg md:text-xl text-brand-rose mb-1 mt-2" data-id="element-56">
              ⭐ KIT ACELERADOR
            </h4>
            <div className="text-3xl md:text-4xl font-bold text-brand-rose mb-3" data-id="element-57">
              $27.990
            </div>
            <p className="text-sm text-brand-text/70 mb-5 flex-grow" data-id="element-58">
              Organizá tu gabinete, llenás la agenda y vivís bien de tu
              profesión.
            </p>
            <CTAButton fullWidth className="text-sm md:text-base py-3.5 animate-pulse-slow" href="#pricing" data-id="element-59">
              ⭐ → LO QUIERO $27.990
            </CTAButton>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs md:text-sm text-brand-muted mb-8" data-id="element-60">
          <div className="flex items-center" data-id="element-61">
            <Lock className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5" data-id="element-62" /> Pago 100%
            seguro
          </div>
          <div className="flex items-center" data-id="element-63">
            <Zap className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5" data-id="element-64" /> Acceso en 5
            minutos
          </div>
          <div className="flex items-center" data-id="element-65">
            <Shield className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5" data-id="element-66" /> Garantía 7
            días
          </div>
          <div className="flex items-center" data-id="element-67">
            <CreditCard className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5" data-id="element-68" /> Mercado
            Pago | Tarjeta | Transferencia
          </div>
        </div>

        <div className="text-sm text-brand-text/60 bg-brand-surfaceLight/20 p-5 md:p-6 rounded-2xl border border-brand-pink/20 space-y-3 text-left md:text-center" data-id="element-69">
          <p data-id="element-70">
            <strong className="text-brand-text/80" data-id="element-71">P.D.:</strong> Tenés dudas.
            Escribinos a{' '}
            <a href="mailto:soportelumenakasha@gmail.com" className="text-brand-rose hover:underline" data-id="element-72">
              soportelumenakasha@gmail.com
            </a>{' '}
            o a{' '}
            <a href="https://instagram.com/lumen.akasha" className="text-brand-rose hover:underline" data-id="element-73">
              @lumen.akasha
            </a>
            . Te respondemos hoy.
          </p>
          <p data-id="element-74">
            Los precios de lanzamiento suben pronto. El mejor momento para
            empezar es ahora.
          </p>
        </div>
      </div>
    </Section>;
};